/**
 * Confirm-модал удаления участника (Фаза 15, B2; 15.1 — вынесен из LobbyRoster
 * в общий компонент, переиспользуется живым рейтингом LiveLeaderboard):
 * «Удалить <ник> из игры? Вернуть нельзя». Порталится в document.body (как и
 * прочие модалы — backdrop-filter карточки); Escape/клик по оверлею — отмена.
 * Подтверждение — колбэк родителя (host-команда kick) и закрытие модала.
 *
 * data-testid-контракт (гейты прода и e2e-демо, НЕ переименовывать):
 * roster-kick-overlay / roster-kick-modal / roster-kick-cancel / roster-kick-confirm.
 */
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

export interface KickConfirmModalProps {
  /** Ник цели — подставляется в текст «Удалить <ник> из игры?». */
  nick: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function KickConfirmModal({ nick, onConfirm, onCancel }: KickConfirmModalProps): JSX.Element {
  const { t } = useTranslation();

  useEffect(() => {
    function onKey(e: KeyboardEvent): void {
      if (e.key === 'Escape') onCancel();
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return createPortal(
    <div
      className="modal-overlay"
      onClick={onCancel}
      data-testid="roster-kick-overlay"
      role="presentation"
    >
      <div
        className="modal kick-modal"
        role="dialog"
        aria-modal="true"
        aria-label={t('roster.kick.title')}
        tabIndex={-1}
        data-testid="roster-kick-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal__head">
          <h3 className="modal__title">{t('roster.kick.title')}</h3>
        </div>
        <div className="modal__body">
          <p className="muted">{t('roster.kick.text', { nick })}</p>
          <div className="btn-row">
            <button
              type="button"
              className="btn btn--ghost"
              data-testid="roster-kick-cancel"
              onClick={onCancel}
            >
              {t('roster.kick.cancel')}
            </button>
            <button
              type="button"
              className="btn"
              data-testid="roster-kick-confirm"
              onClick={onConfirm}
            >
              {t('roster.kick.confirm')}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
